import React, { Fragment, useState } from 'react';
import _isEmpty from 'lodash/isEmpty';

import Table from 'components/customTable';

import ZpFilter from '../../../../components/zpFilter';
import { CAROUSEL_FILTERS,FILTER_PARAMS } from '../../../../components/zpFilter/filterUtils';
import CommonService from '../../../../services/commonService';
import { JOB_BUCKET_GROUP } from '../../../../utils/constant';
import HorizontalBarChart from '../../charts/horizontalBarChart';

const xAxisLabels = ['0%', '20%', '40%', '60%', '80%', '100%'];

const CompanyType = ({
  jobTitle,
  companyTypes,
  companyTypeContentBlurb,
  filterValueRange,
  filterLogEventCallback,
}) => {
  const yAxisLabels = companyTypes.map(({ type }) => type);
  const values = companyTypes.map(({ typePercent }) => typePercent);
  const tableData = companyTypes.map((x) => ({
    ...x,
    typePercentDisplay: x.typePercent + '%',
  }));

  const [compareValues, setCompareValues] = useState([]);
  const [compareJobTitle, setCompareJobTitle] = useState('');

  const handleFilterUpdate = async (_, data) => {
    const { value = jobTitle } = data;
    const jobTitleComparisonValue = value.originalSearch ? value.originalSearch : value;

    if (jobTitleComparisonValue === jobTitle && _isEmpty(compareValues)) {
      return;
    } else if (jobTitleComparisonValue === jobTitle && !_isEmpty(compareValues)) {
      setCompareValues([]);
      setCompareJobTitle('');
      return;
    }

    try {
      const jobTitles = [jobTitleComparisonValue];
      const data = { jobTitles };
      const newCompanyTypes = await CommonService.fetchTitleCompanyTypesData(data);
      const newValues = [];
      yAxisLabels.forEach((label) => {
        const associateType = newCompanyTypes[0].find((companyType) => companyType.type === label);
        newValues.push(associateType ? associateType.typePercent : 0);
      });
      setCompareJobTitle(jobTitles[0]);
      setCompareValues(newValues);
    } catch (error) {
      console.log(error);
    }
  };

  const filterProps = () => {
    return {
      ...CAROUSEL_FILTERS[FILTER_PARAMS.JOB_TITLE],
      buttonText: 'Compare Jobs',
      valueRange: filterValueRange,
      onApply: handleFilterUpdate,
      onClear: handleFilterUpdate,
      options: {
        logEvent: () =>
          filterLogEventCallback(
            `${JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_JOBS}-companyTypes`
          ),
      },
    };
  };

  return (
    <Fragment>
      <h3 className="cmpSectionh4 mb-3">{`The Types Of Companies ${jobTitle} Work In`}</h3>
      {companyTypeContentBlurb && companyTypeContentBlurb.content && (
        <div
          className="mt-3 mb-4"
          dangerouslySetInnerHTML={{ __html: companyTypeContentBlurb.content }}
        />
      )}
      <ZpFilter {...filterProps()} />
      <HorizontalBarChart
        tooltipKey={'companyTypes'}
        yAxisLabels={yAxisLabels}
        xAxisLabels={xAxisLabels}
        values={values}
        compareValues={compareValues}
        yAxisLabelsWidth={'110px'}
        jobTitle={jobTitle}
        compareJobTitle={compareJobTitle}
      />
      <div className="mb-5 z-pt-48">
        <Table
          columnConfig={{
            type: {
              columnName: 'Company Type',
            },
            typePercentDisplay: {
              columnName: 'Percentages',
              customSortByField: 'typePercent',
              // defaultSortDirection: 'desc'
            },
          }}
          bodyData={tableData}
          defaultRowsDisplay={99}
          tableHeaderTitleContent={
            <h3 className="zp-title-h3 text-capitalize z-mb-24">{`${jobTitle} Jobs By Sector`}</h3>
          }
        />
      </div>
    </Fragment>
  );
};

export default CompanyType;
